<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item to="/audit-intern/table">实习生管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $route.meta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-tabs v-model="activeTab"
             type="border-card"
             @tab-click="handleTabClick">
      <el-tab-pane label="基础资料"
                   name="baseInfo"
                   v-if="allowViewEditBase()">
        <layout-panel :show-header="false">
          <el-table :data="baseInfoTableData"
                    border
                    :show-header="false"
                    style="width: 100%">
            <el-table-column prop="label"
                             label="字段"
                             width="150"
                             align="right">
              <template slot-scope="scope">
                <span class="detail-label">{{ scope.row.label }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="value"
                             label="值"
                             align="left">
              <template slot-scope="scope">
                <span class="detail-value"
                      v-if="scope.row.type === 'text'">{{ scope.row.value }}</span>
                <span class="detail-value"
                      v-else-if="scope.row.type === 'map'">{{ scope.row.value }}</span>
                <div class="image-list"
                     v-else-if="scope.row.type === 'images'">
                  <div id="baseInfoPhotoContainer"
                       class="photo-view-container"
                       v-if="scope.row.value && scope.row.value.length > 0">
                    <div class="photo-item"
                         v-for="(url, index) in scope.row.value"
                         :key="index">
                      <img :src="url"
                           @click="onViewPhotos('baseInfo', index)"
                           class="photo-view-image">
                    </div>
                  </div>
                </div>
                <div v-else-if="scope.row.type === 'tags'">
                  <el-tag v-for="(item, index) in scope.row.value"
                          :key="index"
                          size="small"
                          class="project-tag">
                    {{ item }}
                  </el-tag>
                </div>
                <span v-else-if="scope.row.type === 'dateRange'">{{ scope.row.value }}</span>
              </template>
            </el-table-column>
          </el-table>
        </layout-panel>
      </el-tab-pane>

      <!-- 隐私信息标签页 -->
      <el-tab-pane label="隐私信息"
                   name="privateInfo"
                   v-if="allowViewEditPrivate()">
        <layout-panel :show-header="false">
          <el-table :data="privateInfoTableData"
                    border
                    :show-header="false"
                    style="width: 100%">
            <el-table-column prop="label"
                             label="字段"
                             width="150"
                             align="right">
              <template slot-scope="scope">
                <span class="detail-label">{{ scope.row.label }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="value"
                             label="值"
                             align="left">
              <template slot-scope="scope">
                <span class="detail-value"
                      v-if="scope.row.type === 'text'">{{ scope.row.value }}</span>
                <div class="image-list"
                     v-else-if="scope.row.type === 'images'">
                  <div id="privateInfoPhotoContainer"
                       class="photo-view-container"
                       v-if="scope.row.value && scope.row.value.length > 0">
                    <div class="photo-item"
                         v-for="(url, index) in scope.row.value"
                         :key="index">
                      <img :src="url"
                           @click="onViewPhotos('privateInfo', index)"
                           class="photo-view-image">
                    </div>
                  </div>
                </div>
                <div class="image-list"
                     v-else-if="scope.row.type === 'idCardImages'">
                  <div id="idCardPhotosContainer"
                       class="photo-view-container"
                       v-if="scope.row.value && scope.row.value.length > 0">
                    <div class="photo-item"
                         v-for="(url, index) in scope.row.value"
                         :key="index">
                      <img :src="url"
                           @click="onViewPhotos('idCardPhotos', index)"
                           class="photo-view-image id-card-image">
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </layout-panel>
      </el-tab-pane>

      <!-- 资源控制标签页 -->
      <el-tab-pane label="资源控制"
                   name="resourceInfo"
                   v-if="allowViewEditResource()">
        <layout-panel :show-header="false">
          <el-table :data="resourceInfoTableData"
                    border
                    :show-header="false"
                    style="width: 100%">
            <el-table-column prop="label"
                             label="字段"
                             width="150"
                             align="right">
              <template slot-scope="scope">
                <span class="detail-label">{{ scope.row.label }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="value"
                             label="值"
                             align="left">
              <template slot-scope="scope">
                <span class="detail-value"
                      v-if="scope.row.type === 'text'">{{ scope.row.value }}</span>
                <div v-else-if="scope.row.type === 'tags'">
                  <el-tag v-for="(item, index) in scope.row.value"
                          :key="index"
                          size="small"
                          class="project-tag">
                    {{ item }}
                  </el-tag>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </layout-panel>
      </el-tab-pane>
      <!--  操作日志  -->
      <el-tab-pane label="操作日志"
                   name="logInfo">
        <InternLogTable :internUserId="Number(id)"/>
      </el-tab-pane>
    </el-tabs>
    <div class="footer-actions">
      <el-button type="primary"
                 @click="$router.back()">返回
      </el-button>
    </div>
  </div>
</template>

<script>
import 'viewerjs/dist/viewer.css'
import Viewer from 'viewerjs'
import InternLogTable from '../components/InternLogTable.vue'
import { mapState } from 'vuex'
import { auditInternPermissionMixin } from '../audit-intern.mixins.js'

export default {
  mixins: [auditInternPermissionMixin],
  components: {InternLogTable},
  data () {
    return {
      id: 0,
      activeTab: 'baseInfo',
      baseInfo: {
        id: '',
        name: '',
        realname: '',
        employment_type: '',
        office_location: null,
        status: '',
        phone: '',
        mail_address: '',
        school: '',
        major: '',
        education_level: '',
        grade_level: '',
        student_card_photos: [],
        participant_projects: [],
        participant_customers: [],
        assigned_customers: [],
        total_work_days: 0,
        contract_start_date: '',
        contract_end_date: '',
        remark: ''
      },
      privateInfo: {
        bank_card_number: '',
        bank_name: '',
        bank_branch_name: '',
        bank_card_photo: [],
        id_number: '',
        id_card_front_photo: '',
        id_card_back_photo: ''
      },
      resourceInfo: {
        assigned_customers: [],
        ui_roles: [],
        api_roles: []
      },
      viewer: null,
    }
  },
  computed: {
    ...mapState({
      employmentTypeMap: state => state.auditIntern.employmentTypeMap,
      educationLevelMap: state => state.auditIntern.educationLevelMap,
      officeLocationMap: state => state.auditIntern.officeLocationMap,
      gradeLevelMap: state => state.auditIntern.gradeLevelMap,
      statusMap: state => state.auditIntern.statusMap,
    }),
    baseInfoTableData () {
      return [
        {label: '用户ID', value: this.baseInfo.id, type: 'text'},
        {label: '账号', value: this.baseInfo.name, type: 'text'},
        {label: '姓名', value: this.baseInfo.realname, type: 'text'},
        {label: '人员性质', value: this.employmentTypeMap[this.baseInfo.employment_type], type: 'map'},
        {label: '办公地点', value: this.officeLocationMap[this.baseInfo.office_location], type: 'map'},
        {label: '用户状态', value: this.statusMap[this.baseInfo.status], type: 'map'},
        {label: '手机号', value: this.baseInfo.phone, type: 'text'},
        {label: '个人邮箱', value: this.baseInfo.mail_address, type: 'text'},
        {label: '目前所在院校', value: this.baseInfo.school, type: 'text'},
        {label: '专业', value: this.baseInfo.major, type: 'text'},
        {label: '学历', value: this.educationLevelMap[this.baseInfo.education_level], type: 'map'},
        {label: '当前学年段', value: this.gradeLevelMap[this.baseInfo.grade_level], type: 'map'},
        {label: '学生证照片', value: this.baseInfo.student_card_photos, type: 'images'},
        {
          label: '合同时间',
          value: this.baseInfo.contract_start_date ? `${this.baseInfo.contract_start_date} ~ ${this.baseInfo.contract_end_date}` : '',
          type: 'dateRange'
        },
        {label: '备注', value: this.baseInfo.remark, type: 'text'},
        {label: '累计工作天数', value: `${this.baseInfo.total_work_days}天`, type: 'text'},
        {
          label: '累计参与客户',
          value: this.baseInfo.participant_customers.map(item => `${item.name}/${item.id}`),
          type: 'tags'
        },
        {
          label: '累计参与项目',
          value: this.baseInfo.participant_projects.map(item => `${item.name}/${item.id}`),
          type: 'tags'
        },
      ]
    },
    privateInfoTableData () {
      const idCardPhotos = [this.privateInfo.id_card_front_photo, this.privateInfo.id_card_back_photo].filter(Boolean)
      return [
        {label: '银行卡号', value: this.privateInfo.bank_card_number, type: 'text'},
        {label: '银行信息', value: this.privateInfo.bank_name, type: 'text'},
        {label: '开户城市', value: this.privateInfo.bank_branch_name, type: 'text'},
        {label: '银行卡照片', value: this.privateInfo.bank_card_photo, type: 'images'},
        {label: '身份证号', value: this.privateInfo.id_number, type: 'text'},
        {label: '身份证照片', value: idCardPhotos, type: 'idCardImages'},
      ]
    },
    resourceInfoTableData () {
      const formatResourceTags = (items) => {
        if (!Array.isArray(items)) return []
        return items.map(item => {
          if (typeof item === 'object' && item !== null) {
            return `${item.name}/${item.id}`
          }
          return item
        })
      }

      return [
        {label: '客户资源', value: formatResourceTags(this.resourceInfo.assigned_customers), type: 'tags'},
        {label: 'UI权限角色', value: formatResourceTags(this.resourceInfo.ui_roles), type: 'tags'},
        {label: 'API权限角色', value: formatResourceTags(this.resourceInfo.api_roles), type: 'tags'},
      ]
    },
  },
  beforeRouteEnter (_to, _from, next) {
    next(vm => vm.onLoad())
  },
  beforeRouteUpdate (_to, _from, next) {
    this.onLoad()
    next()
  },
  created () {},
  mounted () {},
  methods: {
    ...request.map([
      'getInternBaseInfoApi',
      'getInternPrivateInfoApi'
    ]),
    onViewPhotos (containerType, index) {
      let containerId = ''
      switch (containerType) {
        case 'baseInfo':
          containerId = 'baseInfoPhotoContainer'
          break
        case 'privateInfo':
          containerId = 'privateInfoPhotoContainer'
          break
        case 'idCardPhotos':
          containerId = 'idCardPhotosContainer'
          break
      }
      if (this.viewer) {
        this.viewer.destroy()
      }
      this.viewer = new Viewer(document.getElementById(containerId))
      this.viewer.view(index)
    },
    onLoad () {
      if (this.$route.params.id) {
        this.id = this.$route.params.id
        // 根据权限设置默认标签页
        if (this.allowViewEditBase()) {
          this.activeTab = 'baseInfo'
        } else if (this.allowViewEditPrivate()) {
          this.activeTab = 'privateInfo'
        } else if (this.allowViewEditResource()) {
          this.activeTab = 'resourceInfo'
        } else {
          this.activeTab = 'logInfo'
        }

        if (this.allowViewEditBase() || this.allowViewEditResource()) {
          this.fetchBaseInfo()
        }
        if (this.allowViewEditPrivate()) {
          this.fetchPrivateInfo()
        }
      }
    },
    fetchBaseInfo () {
      request.common('getInternBaseInfoApi', {id: this.id}).then(({data}) => {
        if (data) {
          this.baseInfo = {...this.baseInfo, ...data}
          // 同时获取资源控制信息
          if (this.allowViewEditResource()) {
            this.resourceInfo.assigned_customers = data.assigned_customers || []
            this.resourceInfo.ui_roles = data.ui_roles || []
            this.resourceInfo.api_roles = data.api_roles || []
          }
        }
      }).catch(err => {
        this.$message.error(err.message || '获取基础资料失败')
      })
    },
    fetchPrivateInfo () {
      request.common('getInternPrivateInfoApi', {id: this.id}).then(({data}) => {
        if (data) {
          this.privateInfo = {...this.privateInfo, ...data}
        }
      }).catch(err => {
        this.$message.error(err.message || '获取隐私信息失败')
      })
    },
    handleTabClick (tab) {
      if (!this.id) return

      const tabName = tab.name
      if (tabName === 'baseInfo' && this.allowViewEditBase()) {
        this.fetchBaseInfo()
      } else if (tabName === 'privateInfo' && this.allowViewEditPrivate()) {
        this.fetchPrivateInfo()
      } else if (tabName === 'resourceInfo' && this.allowViewEditResource()) {
        this.fetchBaseInfo()
      }
    }
  }
}
</script>

<style lang="scss"
       scoped>
.detail-label {
  color: #606266;
  font-weight: 500;
}

.detail-value {
  color: #303133;
}

.image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.photo-view-container {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.photo-item {
  position: relative;
  display: inline-block;
}

.photo-view-image {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  cursor: zoom-in;
  transition: border-color 0.3s, transform 0.2s;

  &:hover {
    border-color: #409eff;
    transform: scale(1.05);
  }
}

.id-card-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 16px;
}

.id-card-label {
  font-size: 12px;
  color: #909399;
  margin-bottom: 4px;
}

.id-card-image {
  width: 160px;
  height: 100px;
}

.project-tag {
  margin-right: 8px;
  margin-bottom: 4px;
}

.footer-actions {
  margin-top: -5px;
  padding-top: 20px;
  border-top: 1px solid #e4e7ed;
}
</style>



// WEBPACK FOOTER //
// src/views/audit-intern/pages/AuditInternDetail.vue